import { render, staticRenderFns } from "./CashRegister.vue?vue&type=template&id=5b098afe&scoped=true"
import script from "./CashRegister.vue?vue&type=script&lang=js"
export * from "./CashRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b098afe",
  null
  
)

export default component.exports